import * as React from 'react';
import { DocumentCardDetails as FabricDocumentCardDetails } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DocumentCardDetails = props => /*#__PURE__*/_jsx(FabricDocumentCardDetails, {
  children: props.children
});